import { Table } from "antd";
import { SetStepSummary } from "components/CC/RunHistory/StepDetails/utils/types";
import { DrawerCollapsible } from "components/UI/DrawerCollapsible/DrawerCollapsible";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";

import type { ColumnsType } from "antd/es/table";

interface SetRow {
    key: string;
    parameter: string;
    value: string;
}

export interface StepDetailSetProps {
    extractedData: SetStepSummary;
}

export const StepDetailSet: FC<StepDetailSetProps> = ({ extractedData }) => {
    const { t } = usePaldockTranslation("drawers.step-detail.set");

    const rows: SetRow[] = extractedData.values.map(({ key, value }) => ({
        key,
        parameter: key,
        value,
    }));

    const columns: ColumnsType<SetRow> = [
        { title: t("parameter"), dataIndex: "parameter", key: "parameter" },
        { title: t("value"), dataIndex: "value", key: "value" },
    ];

    return (
        <DrawerCollapsible title={t("data")}>
            <Table columns={columns} dataSource={rows} pagination={false} size="small" bordered={false} />
        </DrawerCollapsible>
    );
};
